import { useEffect } from 'react';
import { useSelector } from 'react-redux';

/** Kameleoon Wellness test will return true if the parameter
 * `wellnessPath` exists, no matter the value
 */
export const useKameleoonWellnessTest = () => {
  const parameters = useSelector(({ quoting }) => quoting.parameters);
  useEffect(() => {
    if (parameters.wellnessPath) {
      // Debug purposes only for Ticket 218094
      // eslint-disable-next-line no-console
      console.log('Kameleoon wellness test path enabled');
    }
  }, [parameters]);

  return parameters.wellnessPath;
};
